// 搜索历史
export const BIZ_SEARCH_HISTORY = `BIZ_SEARCH_HISTORY`;
// 搜索关键词
export const BIZ_SEARCH_KEYWORD = 'BIZ_SEARCH_KEYWORD';
// token
export const BIZ_TOKEN = `BIZ_TOKEN`;

//登录的用户信息
export const BIZ_USERINFO = `BIZ_USERINFO`;

// 当前购物车
export const BIZ_CURRENT_CART ='BIZ_CURRENT_CART';

// 语言标示
export const BIZ_LANG = `BIZ_LANG`;
// 货币标示（用户所选展示币种）
export const BIZ_CURRENCY = `BIZ_CURRENCY`;
// 购物车
export const BIZ_CART = `BIZ_CART`;

// 购物车商品项目
export const BIZ_CART_ITEMS = `BIZ_CART_ITEMS`;

// 在线消息最后一条key
export const BIZ_MESSAGE_LAST_ID = `BIZ_MESSAGE_LAST_ID`;
// vuex缓存
export const BIZ_VUEX = `vuex`;

//顶部搜索栏 搜索结果
export  const BIZ_SEARCH_RESULT = `BIZ_SEARCH_RESULT`;
// 提醒发货列表
export const BIZ_REMIND_ORDER = 'BIZ_REMIND_ORDER'


/**
 * 系统语言map
 */
export const BIZ_LANGUAGE_MAP = {
  /**
   * 中文简体
   */
  'zhCN': 'zh-CN',
  /**
   * 中文繁体
   */
  'zhTW': 'zh-TW',
  /**
   * 英文
   */
  'en': 'en',
  'ja':'ja',
  'de':'de',
  'ms':'ms',
  "af":"af",
  "th":"th",
  "el":"el",
  "pt":"pt",
  "es":"es",
  "fr":"fr",
  "ru":"ru",
  "it":"it",
  "tr":"tr",
  "ko":"ko",
  "ph":"ph",
  "ar":"ar",
  "id":"id",
  "hi":"hi",
  "vi":"vi"
}

export const BASE_AREA_CODE = '93'